import '@/assets/css/ui.css'
import '@/assets/css/style.css'

import Vue from 'vue'
import App from './App.vue'

//tips_data
globalThis.tips_data = {};

globalThis.mainApp = null;

import qs from "qs"
Vue.prototype.$qs = qs

//store
// import store from "@/assets/js/store.js";
// Vue.prototype.$store = store;

//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
//引入样式
// import style (>= Swiper 6.x)
import 'swiper/dist/css/swiper.min.css'
 Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)

import {
  imgsPreloader
} from '@/assets/js/imgPreloader.js';
import imgPreloaderList from '@/assets/js/imgPreloaderList.js';

//wx_share
import wx from '@/assets/js/wxapi.jsonp.js';

import GLOBAL from '@/assets/js/global.js'
Vue.prototype.$global = GLOBAL

//axios
import axios from 'axios';
Vue.prototype.$axios = axios;

//login
import mslogin from '@/assets/js/msLogin.js'
Vue.prototype.$mslogin = mslogin
mslogin.defaults.loginUrl = GLOBAL.ajax_url_map.login

//clipboard
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

//FREE
import Free_login from '@/assets/js/freeLogin.js';
Vue.prototype.Free_login = Free_login;

//Toast
import Toast from '@/components/Toast'
Vue.prototype.$toast = Toast

//ajxa_map
globalThis.ajax_url_map = GLOBAL.ajax_url_map;



//clipboard
Vue.prototype.clipboard = clipboard;

//loading
import Loading from '@/components/loading/Loading.vue';
Vue.component("Loading", Loading);

//item_view
import gameItem from '@/components/itemview.vue'
Vue.component('game-item', gameItem)

//item_tips
import Item_Tips from '@/components/ItemTips/itemTips.vue';
Vue.component('item-tips',Item_Tips);

Vue.prototype.$item_tips = function(id,type){
  //if(GLOBAL.deviceType == 'pc') return;
  mainApp.$refs.app.$refs.tips.visible = true;
  mainApp.$refs.app.$refs.tips.item_id = id;

  let _type = GLOBAL.tipsImg.indexOf(id) > -1 ? 'img' : 'text';
  mainApp.$refs.app.$refs.tips.type = _type;
};

Vue.prototype.$user_update = function(){
  //mainApp.update_evt();
};

Vue.prototype.$evt_update = function(){
  //mainApp.$refs.app.$refs.token.init();
};

(async () => {
  await imgsPreloader(imgPreloaderList);
  //关闭加载弹框
  document.querySelector('.loading').style.display = 'none';
  /* eslint-disable no-new */
  mainApp = new Vue({
    el: '#app',
    components: {
      'App' : App,
    },
    template: '<App ref="app" :ready="ready"/>',
    data() {
      return {
        ready : false,
      }
    },
    mounted (){
    
        wx.wxInit({
          title: GLOBAL.wx_share_text.title, // 分享标题
          desc: GLOBAL.wx_share_text.desc, // 分享描述
          link: GLOBAL.domain, // 分享链接
          imgUrl: GLOBAL.wx_share_text.imgUrl, // 分享图标            
        });  
    
      },
    methods: {
      get_user_info() {
        // 调用免登录接口，进行免登录验证
        //TODO 梦平台免登录
        let _this = this;

        Free_login.free_login_lazy(
          this.ua.uid, {
            mplat: ajax_url_map.mplat,
            kd: ajax_url_map.freelogin,
          },
          function (response) {
            if (typeof response !== 'undefined') {
              _this.token = response.data ? response.data : response;
            }
            _this.update_evt();

          }
        );
      },
      update_login() {
        let _this = this;

        return new Promise((resolve, reject) => {
          _this.$axios.get(ajax_url_map.userinfo)
            .then(
              res => {
                _this.login = 1;
                _this.ua = res.data;

                console.log(res.userInfo)

                this.$store.commit("$_setLogin", 1);
                
                if(res.userInfo){
                    this.$store.commit("$_setAccount", res.userInfo);
                }
                
                if(res.data){
                    this.$store.commit("$_setUserinfo", res.data);
                }

                if(this.share){
                  this.share_accepet ();
                }
                
                resolve(res);
              },
              rej => {
                //reject(rej);
                this.ready = true
                //TODO share Warn
                if(this.share)return this.$share_warn();
              }
            )
            .catch(function (error) {
              console.log(error);
            });
        });

      },
      update_evt() {
        let _this = this;

        async function _evt_init() {
          let _data = await _this.update_login();

          if (_data.code == 402) {
            _this.ready = true;
            return _this.$bind_modal();
          }

          _this.$axios.post(ajax_url_map.token_info)
            .then(
              res => {
                _this.evt_info = res.data;
                _this.ready = true;
              },
              rej => {
                _this.ready = true;
              }
            )
        }

        _evt_init();
      },
      evt_info_query (){
        let _this = this;

        _this.$axios.post(ajax_url_map.userinfo)
        .then(
          res => {
            _this.evt_info = res.data;
            _this.ready = true;
          },
          rej => {
            _this.ready = true;
          }
        )        
      },
      share_accepet (){
        let _this = this;

        _this.$axios.post(ajax_url_map.share_gift,this.$qs.stringify({
          share : _this.share,
        }))
        .then(
          res => {
            _this.$toast('助力成功，恭喜获得寰行神州分享礼*1');
          },
          rej => {
            _this.$toast(rej.message)
          }
        )         
      },      
    },
  })
})();



// WEBPACK FOOTER //
// ./src/main.js